function getHeader(headers, name) {
  if (!headers) {
    return undefined
  }

  if (typeof headers.get === 'function') {
    return headers.get(name)
  }

  return headers[name] || headers[name.toLowerCase()] || headers[name.toUpperCase()]
}

function decodeFileName(value) {
  try {
    return decodeURIComponent(value)
  } catch {
    return value
  }
}

export function getFileNameFromHeaders(headers, fallbackName = 'archivo') {
  const contentDisposition = getHeader(headers, 'content-disposition') || ''
  const encodedName = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i)

  if (encodedName && encodedName[1]) {
    return decodeFileName(encodedName[1])
  }

  const plainName = contentDisposition.match(/filename\s*=\s*"?([^";]+)"?/i)
  return plainName && plainName[1] ? decodeFileName(plainName[1]) : fallbackName
}

export function downloadArrayBufferResponse(response, fallbackName) {
  const mimeType = getHeader(response && response.headers, 'content-type') || 'application/octet-stream'
  const fileName = getFileNameFromHeaders(response && response.headers, fallbackName)
  const blob = new Blob([response.data], { type: mimeType })

  if (navigator.msSaveOrOpenBlob) {
    navigator.msSaveBlob(blob, fileName)
    return fileName
  }

  const objectUrl = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = objectUrl
  link.target = '_blank'
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.setTimeout(() => window.URL.revokeObjectURL(objectUrl), 0)

  return fileName
}